import { render } from "./AlzataSignIn.vue?vue&type=template&id=645dd9ea"
import script from "./AlzataSignIn.vue?vue&type=script&lang=js"
export * from "./AlzataSignIn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__